import { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { clearUserData } from 'utils/cleardata';

const useLogoutHandler = () => {
  const { instance } = useMsal();
  return useCallback(() => {
    clearUserData();
    instance.logoutRedirect();
  }, [instance]);
};

export default useLogoutHandler;
